export const isOlderThan24Hours = (dateStr) => {
  const diffMs = Date.now() - new Date(dateStr).getTime();
  return diffMs > 24 * 60 * 60 * 1000;
};